import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { closeDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { BreadCrumbProps } from "models/propTypes/navigationPropTypes";
//#endregion
//#region components
import { Breadcrumbs, Typography, Avatar, Grid } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link, useLocation } from "react-router-dom";
//#endregion
import LogoSmall from "images/logo-small.png";
import cssExports from "theme/styles/main.module.scss";
import { UrlHelper } from "utils/helpers";

const BreadCrumb: React.FC<BreadCrumbProps> = (props) => {
  const { showHome, prevItems, current } = props;
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const location = useLocation();
  const backgroundSearch = (location as any)?.state?.background?.search as string | undefined;
  const preserveSearch = (location as any)?.state?.preserveSearch as boolean | undefined;
  const buildPreservedSearch = (raw: string | undefined): string => {
    const params = new URLSearchParams((raw ?? "").startsWith("?") ? (raw as string).slice(1) : (raw ?? ""));
    params.delete("subpage");
    const queryString = params.toString();
    return queryString ? `?${queryString}` : "";
  };
  const preservedSearch = preserveSearch ? buildPreservedSearch(backgroundSearch) : "";

  const onNavigation = () => {
    dispatch(closeDialog());
  };
  return (
    <Grid item container className={props.className}>
      <Breadcrumbs
        classes={{
          separator: cssExports.navigationSeparator,
        }}
        separator={<NavigateNextIcon className={cssExports.navigationIcon} />}
        aria-label="breadcrumb"
        className={cssExports.navigationContainer}
      >
        {showHome && (
          <Link to={UrlHelper.formatPath("/")} className={cssExports.navigationHome} onClick={onNavigation}>
            <Avatar alt={"Wint"} src={LogoSmall} className={cssExports.navigationHomeLogo} />
          </Link>
        )}

        {prevItems.slice(-1).map((item, index) => {
          return item.href !== undefined ? (
            <Link
              key={`breadcrumb-${index}`}
              to={item.href.includes("?") ? item.href : `${item.href}${preservedSearch}`}
              className={cssExports.navigationLink}
              onClick={onNavigation}
            >
              {item.text}
            </Link>
          ) : (
            <div key={`breadcrumb-${index}`} className={cssExports.navigationLink}>
              {item.text}
            </div>
          );
        })}
        {current && <Typography className={cssExports.navigationCurrent}>{current}</Typography>}
      </Breadcrumbs>

      {props.showEndSeparator && (
        <Grid item className={cssExports.emptySeparator}>
          <NavigateNextIcon className={cssExports.navigationIcon} />
        </Grid>
      )}
    </Grid>
  );
};

export default BreadCrumb;
